import CheckCircle from "~icons/material-symbols/check-circle-outline";
import { css } from "../../../styled-system/css";
import { t } from "../../libs/i18n";

type ChargeCompleteModalProps = {
  onClose: () => void;
};

export function ChargeCompleteModal({ onClose }: ChargeCompleteModalProps) {
  return (
    <div
      className={css({
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(226, 226, 226, 0.5)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        px: "20px",
      })}
    >
      <div
        className={css({
          backgroundColor: "surface.primary",
          border: "1px solid",
          borderColor: "border.secondary",
          borderRadius: "16px",
          boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.04)",
          padding: "24px",
          width: "100%",
          maxWidth: "350px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
        })}
      >
        <h2
          className={css({
            fontSize: "18px",
            lineHeight: "1.35",
            fontWeight: "600",
            color: "text.primary",
            textAlign: "center",
          })}
        >
          {t("チャージが完了しました")}
        </h2>

        <CheckCircle
          className={css({
            w: "64px",
            h: "64px",
            color: "surface.accentSuccess",
          })}
        />

        <button
          type="button"
          className={css({
            minH: "48px",
            width: "100%",
            backgroundColor: "surface.secondary",
            color: "text.primary",
            border: "1px solid",
            borderColor: "border.secondary",
            borderRadius: "12px",
            px: "24px",
            py: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            lineHeight: "1.25",
            fontWeight: "600",
            boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.03)",
          })}
          onClick={onClose}
        >
          {t("閉じる")}
        </button>
      </div>
    </div>
  );
}
